export const PER_PAGE = 100;
export const BATCH_SIZE = 100;

export const getPaginationTotal = (data: unknown[] | undefined, hasMoreData: boolean) => {
  const len = data?.length || 0;
  const batchSize = BATCH_SIZE;
  const isTotalUnknown = len > 0 && len % batchSize === 0;
  return isTotalUnknown && hasMoreData ? len + 1 : len;
};
